import type { ActivityAction, ActivityKind } from '@/api/types'

// 작업 내역의 낱말(F-30). 백엔드가 고른 순간에 이름을 붙인다 —
// `Record<ActivityAction, …>` 이라 스펙에 낱말이 늘면 여기가 빌 때 타입 검사가 막는다.
//
// 한 줄은 "무엇이 · 어떻게 됐다" 로 읽힌다: 주어는 그 줄의 이름(노드·클러스터·VM)이고
// 여기 있는 것은 술어뿐이다. 그래서 문장이 아니라 짧은 말이다.

export const actionWord: Record<ActivityAction, string> = {
  node_installing: '설치 시작',
  node_installed: '설치 완료',
  node_reinstalled: '재설치',
  node_install_loop: '설치 반복 중단 — 설치 매체를 빼세요',
  node_founded_cluster: '클러스터 창설',
  node_joined_cluster: '클러스터 참여',
  node_ready: '노드 준비 완료',
  node_failed: '노드 준비 실패',
  node_left_cluster: '클러스터 탈퇴',
  node_removed: '노드 제거',
  cluster_rediscovered: '클러스터 재등록',
  cluster_removed: '클러스터 제거',
  cluster_relinked: '새 관리 주소로 재결속',
  cluster_relink_stuck: '재결속 멈춤',
  guest_network_ready: '게스트 망 준비',
  image_ready: '이미지 준비',
  image_failed: '이미지 실패',
  image_retired: '이미지 교체',
  vm_requested: 'VM 신청',
  vm_approved: 'VM 승인',
  vm_rejected: 'VM 반려',
  vm_ready: 'VM 준비 완료',
  vm_failed: 'VM 만들기 실패',
  vm_first_access: '첫 접속',
  vm_app_published: '앱 공개',
  vm_key_rotated: '키 재발급',
  vm_change_requested: '변경 신청',
  vm_change_approved: '변경 승인',
  vm_change_applied: '변경 적용',
  vm_change_failed: '변경 실패',
  vm_gpu_attached: 'GPU 부착',
  vm_disk_added: '디스크 추가',
  vm_disk_resized: '디스크 확장',
  vm_disk_removed: '디스크 삭제',
  vm_unreachable: 'VM 응답 없음',
  vm_reachable: 'VM 응답 복구',
  vm_returned: 'VM 반납',
  vm_restored: 'VM 되살림',
  vm_purged: 'VM 파기',
}

// 잘못된 것으로 읽혀야 하는 줄. 색이 도는 것은 이것뿐이다 —
// 나머지는 다 정상적인 진행이라 색으로 구분할 것이 없다.
const FAILED = new Set<ActivityAction>([
  'node_failed',
  'image_failed',
  'vm_failed',
  'vm_change_failed',
  'vm_unreachable',
])

export const isFailure = (action: ActivityAction) => FAILED.has(action)

export const kindWord: Record<ActivityKind, string> = {
  node: '노드',
  cluster: '클러스터',
  vm: 'VM',
}
